import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import PaymentResultShell from './PaymentResultShell';

const Failure = () => {
  const [searchParams] = useSearchParams();
  const status = searchParams.get('collection_status') || searchParams.get('status');

  useEffect(() => {
    document.title = 'Pago no completado · Privistore';
    return () => {
      document.title = 'Privistore';
    };
  }, []);

  return (
    <PaymentResultShell
      variant="failure"
      title="No se pudo completar el pago"
      subtitle="Algo falló o cancelaste el proceso. No se te ha cobrado por este intento. Podés volver al carrito e intentar de nuevo con otro medio."
      primaryLabel="Ir al carrito"
      primaryTo="/carrito"
      secondaryLabel="Seguir comprando"
      secondaryTo="/productos"
    >
      {status && (
        <p className="mp-result__subtitle" style={{ marginTop: '-0.5rem' }}>
          Estado informado: <strong>{status}</strong>
        </p>
      )}
    </PaymentResultShell>
  );
};

export default Failure;
